export const isStarted = (startTime: string) => {
  if(!startTime) return true;
  const currentDate = new Date(Date.now());
  const startDate = new Date(startTime);
  if (!startTime) return true;
  return currentDate >= startDate;
};
